import React from 'react';
import { connect } from 'react-redux';
import { Field, Form as FormFinal } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { OnChange } from 'react-final-form-listeners';
import { Form, Col, Card, Button, Alert, Spinner } from 'react-bootstrap';
import { Check } from '@styled-icons/boxicons-regular/Check';
import Echo from 'laravel-echo';
import { getToken } from '../../../../utils/tokencidtechapi';

//Actions
import { novoatualiza, eventoselecionado as eventoselecionadoaction, pesquisa } from '../../../../actions/eventos/eventos';

//Components
import { 
    campotexto,
    camporadio,
    Campocalendario,
    Campoupload } from '../../../../components/forms/campos/campos';

//Tools
import { LogErrorLabels, getPreImagesCampo, getCamposInitialValues } from '../../../../components/forms/utils/toolsforms';

import { getUserGeren } from '../../../../utils/authusuariogerenciamento';

//Helpers
import { TelaModalLivre } from '../../../../helpers/TelaModal';

class FormEventos extends React.Component {

    state = {        
        tipocad: 'N',
        showmodalerrors: false
    }

    componentDidMount(){
        const options = {        
            broadcaster: 'pusher',
            key: "a7af8c5ffc1f70d3a522",
            cluster: "us2",            
            encrypted: true,
            authEndpoint: "https://regtronweb.com.br/cidtechweb/broadcasting/auth",
            auth: {
                headers: {
                    Authorization: 'Bearer ' + getToken(),
                    Accept: 'application/json',
                },
            },
        };
          
        this.echo = new Echo(options);
        this.echo.channel(`evento-modified`)
        .listen('.pedido.recebido', ev => console.log(ev));
    }

    handleSubmit = async (form) => {
        const user = getUserGeren();
        const dados = {
            ...form,
            idpromotora: user.idpromotora
        }        
        await this.props.novoatualiza(dados);
        await this.props.pesquisa({idpromotora: user.idpromotora});
    }
    
    handleTipoCad = (value) => {
        this.setState({
            tipocad: value
        })
    }

    handleValidacao = (values) => {

        let errors = {};

        if(!values.portugues){
            errors.portugues = 'Obrigatório';
        }

        if(this.state.tipocad === 'N'){
            if(!values.imagemevento){
                errors.imagemevento = 'Obrigatório';
            }
        }

        if(this.state.tipocad === 'S'){
            if(!values.imagemcongresso){
                errors.imagemcongresso = 'Obrigatório';
            }
        }

        if(!values.datainicial){
            errors.datainicial = 'Obrigatório';
        }

        if(!values.datafinal){
            errors.datafinal = 'Obrigatório';
        }

        if(!values.horainicial){
            errors.horainicial = 'Obrigatório';
        }

        if(!values.horafinal){
            errors.horafinal = 'Obrigatório';
        }

        if(!values.encerra){
            errors.encerra = 'Obrigatório';
        }
        
        return errors;
    }

    handleModalCadastro = (form) => {
        this.props.eventoselecionadoaction({});
        form.reset();
    }

    handleModalErrors = () => {
        this.setState({
            showmodalerrors: this.state.showmodalerrors?false:true
        });
    }

    handleSubmitLog = () => {
        setTimeout(() => {
            this.handleModalErrors();
        },500);
    }

    handleErrorSubmit = (props) => {
        if(props.submitFailed === true){
            const errors_labels = LogErrorLabels(props);                        
            return (
                <TelaModalLivre titulo="Campos obrigatórios" show={this.state.showmodalerrors} handleCloseModal={this.handleModalErrors}>
                    {errors_labels.map((itens, indice) => {
                        return (                                
                            <Alert variant="warning" key={indice}>{itens}</Alert>
                        )
                    })}
                </TelaModalLivre>
            )
        }
    }

    handleDadosForm = () => {
        return [
            {
                formsessao: 'Qual o tipo de Evento deseja incluir?',
                rows: [
                    [
                        { md: 4, type: "hidden", name: 'idevento', label: '', component: 'texto', },
                    ],
                    [
                        { md: 4, type: "radio", name: 'somenteseminario', label: 'Não', component: 'checkbox', value: 'N' },
                        { md: 4, type: "radio", name: 'somenteseminario', label: 'Sim', component: 'checkbox', value: 'S' },
                        { md: 4, type: "radio", name: 'somenteseminario', label: 'Sim', component: 'checkbox', value: 'T' },                        
                    ]
                ]
            },{
                formsessao: 'Nome do Evento',
                rows: [
                    [
                        { md: 4, type: "text", name: 'portugues', label: 'Português', component: 'texto'},
                        { md: 4, type: "text", name: 'ingles', label: 'Inglês', component: 'texto'},
                        { md: 4, type: "text", name: 'espanhol', label: 'Espanhol', component: 'texto' },
                    ],[
                        { md: 4, type: "text", name: 'sigladoevento', label: 'Sigla do Evento', component: 'texto' },
                    ]
                ]
            },{
                formsessao: 'Imagem do Evento Feira',
                rows: [
                    [
                        { md: 4, type: "text", name: 'imagemevento', label: 'Português', component: 'imagem'},
                        { md: 4, type: "text", name: 'imagemeventoingles', label: 'Inglês', component: 'imagem'},
                        { md: 4, type: "text", name: 'imagemeventoespanhol', label: 'Espanhol', component: 'imagem' },
                    ]
                ]
            },{
                formsessao: 'Imagem do Evento Feira Mobile 270x44',
                rows: [
                    [
                        { md: 4, type: "text", name: 'imagemeventomobile', label: 'Português', component: 'imagem'},
                        { md: 4, type: "text", name: 'imagemeventomobileingles', label: 'Inglês', component: 'imagem'},
                        { md: 4, type: "text", name: 'imagemeventomobileespanhol', label: 'Espanhol', component: 'imagem' },
                    ]
                ]
            },{
                formsessao: 'Imagem do Congresso',
                rows: [
                    [
                        { md: 4, type: "text", name: 'imagemcongresso', label: 'Português', component: 'imagem'},
                        { md: 4, type: "text", name: 'imagemcongressoingles', label: 'Inglês', component: 'imagem'},
                        { md: 4, type: "text", name: 'imagemcongressoespanhol', label: 'Espanhol', component: 'imagem' },
                    ]
                ]
            },
            
            {
                formsessao: 'Validação de Cadastro de Usuários?',
                rows: [
                    [
                        { md: 4, type: "radio", name: 'validacadastro', label: 'Sim, envio de código de validação por e-mail', component: 'radio', value: "S"},
                        { md: 4, type: "radio", name: 'imagemcongressoingles', label: 'Não', component: 'radio', value: "N"},                        
                    ]
                ]
            },{
                formsessao: 'Data e Horário',
                rows: [
                    [
                        { md: 4, type: "text", name: 'datainicial', label: 'Português', component: 'texto'},
                        { md: 4, type: "text", name: 'datafinal', label: 'Inglês', component: 'texto'},
                        { md: 4, type: "text", name: 'horainicial', label: 'Espanhol', component: 'texto' },
                        { md: 4, type: "text", name: 'horafinal', label: 'Espanhol', component: 'texto' },
                    ],[
                        { md: 4, type: "text", name: 'encerra', label: 'Data de Encerramento do Credenciamento', component: 'texto' },                        
                    ]
                ]
            }                        
        ];
    }
        
    render(){
        
        const eventoselecionado = Object.keys(this.props.eventoselecionado).length?JSON.parse(this.props.eventoselecionado):{somenteseminario: 'N'};
        
        return (
            <FormFinal
            validate={this.handleValidacao}
            onSubmit={this.handleSubmit}
            initialValues={getCamposInitialValues(this.handleDadosForm(), eventoselecionado)}
            mutators={{                    
                ...arrayMutators,
                setValue: ([field, value], state, { changeValue }) => {
                    changeValue(state, field, () => value)
                }                    
            }}
            render={({ pristine, form, handleSubmit, submitSucceeded, submitFailed, errors }) => {
                
                const gravou = submitSucceeded&&this.props.cadastroEvento&&this.props.cadastroEvento.idevento?true:false;
                this.myform = form;
                return (
                <form onSubmit={handleSubmit} id="formcadevento" className="formcadevento">
                    <Field type='hidden' name='idevento' component={campotexto} />
                    <TelaModalLivre show={gravou} handleCloseModal={() => this.handleModalCadastro(form)}>
                        <Alert variant="success">Cadastro Feito com Sucesso</Alert>
                    </TelaModalLivre>
                    {this.handleErrorSubmit({submitFailed: submitFailed, errors: errors})}
                    {eventoselecionado&&eventoselecionado.idevento?
                    null
                    :
                    <Card className='mb-3'>                        
                        <Card.Header><Card.Title>Qual o tipo de Evento deseja incluir?</Card.Title></Card.Header>
                        <Card.Body>
                            <Form.Row>                        
                                <Form.Group as={Col} md="4" controlId="somenteseminario">
                                    <Field type='radio'                                    
                                    label="Feira" name='somenteseminario' component={camporadio} value="N" />
                                </Form.Group>                        
                                <Form.Group as={Col} md="4" controlId="somenteseminario">
                                    <Field type='radio'                                    
                                    label="Congresso" name='somenteseminario' component={camporadio} value="S" />
                                </Form.Group>
                                <Form.Group as={Col} md="4" controlId="somenteseminario">
                                    <Field 
                                    type='radio'
                                    label="Ticket" name='somenteseminario' component={camporadio} value="T" />                            
                                </Form.Group>                           
                                <OnChange name="somenteseminario">
                                    {this.handleTipoCad}                                    
                                </OnChange>
                            </Form.Row>
                        </Card.Body>
                    </Card>                    
                    }
                    <Card className='mb-3'>
                        <Card.Header><Card.Title>Nome do Evento</Card.Title></Card.Header>
                        <Card.Body>
                            <Form.Row>                        
                                <Form.Group as={Col} md="4" controlId="portugues">
                                    <Field type='text'
                                    label="Português" name='portugues' component={campotexto} />
                                </Form.Group>                        
                                <Form.Group as={Col} md="4" controlId="ingles">
                                    <Field type='text'                                    
                                    label="Inglês" name='ingles' component={campotexto} />
                                </Form.Group>
                                <Form.Group as={Col} md="4" controlId="espanhol">
                                    <Field 
                                    type='text'
                                    label="Espanhol" name='espanhol' component={campotexto} />
                                </Form.Group>                           
                            </Form.Row>  
                            <Form.Row>                        
                                <Form.Group as={Col} md="4" controlId="sigladoevento">
                                    <Field type='text'
                                    placeholder="Ex. MTEXPO"
                                    label="Sigla do evento" name='sigladoevento' mask="**********" component={campotexto} />
                                </Form.Group>
                            </Form.Row>
                        </Card.Body>
                    </Card>
                    {this.state.tipocad==='N'?
                    <>
                    <Card className='mb-3'>
                        <Card.Header><Card.Title>Imagem do Evento Feira</Card.Title></Card.Header>
                        <Card.Body>
                            <Form.Row>                        
                                <Form.Group as={Col} md="4" controlId="imagemevento">
                                    <Field  component={Campoupload}
                                    form={form}                                    
                                    name='imagemevento'
                                    label="Imagem do Evento"
                                    numeroupload={1}
                                    preimagens={getPreImagesCampo('imagemevento', eventoselecionado.imagens)}
                                    info="Formato jpg ou png, tamanho máximo de 25k"
                                    resolutionWidth={650}
                                    resolutionHeight={450}
                                    resolutionType="less"
                                    infoResolution="Máximo 650x450"
                                    actionRemoveItem={this.props.eventoselecionadoaction}
                                    itensInitialize={eventoselecionado}
                                    />                                    
                                </Form.Group>                        
                                <Form.Group as={Col} md="4" controlId="imagemeventoingles">
                                    <Field  component={Campoupload}
                                    form={form}                                    
                                    name='imagemeventoingles'
                                    label="Imagem do Evento Inglês"
                                    preimagens={getPreImagesCampo('imagemeventoingles', eventoselecionado.imagens)}
                                    info="Formato jpg ou png, tamanho máximo de 25k"
                                    numeroupload={1}
                                    resolutionWidth={650}
                                    resolutionHeight={450}
                                    resolutionType="less"
                                    infoResolution="Máximo 650x450"
                                    actionRemoveItem={this.props.eventoselecionadoaction}
                                    itensInitialize={eventoselecionado}
                                    />                                    
                                </Form.Group>
                                <Form.Group as={Col} md="4" controlId="imagemeventoespanhol">
                                    <Field  component={Campoupload}
                                    form={form}                                    
                                    name='imagemeventoespanhol'
                                    label="Imagem do Evento Espanhol"
                                    preimagens={getPreImagesCampo('imagemeventoespanhol', eventoselecionado.imagens)}
                                    info="Formato jpg ou png, tamanho máximo de 25k"
                                    numeroupload={1}
                                    resolutionWidth={650}
                                    resolutionHeight={450}
                                    resolutionType="less"
                                    infoResolution="Máximo 650x450"
                                    actionRemoveItem={this.props.eventoselecionadoaction}
                                    itensInitialize={eventoselecionado}
                                    />                                    
                                </Form.Group>                           
                            </Form.Row>                            
                        </Card.Body>
                    </Card>
                    <Card className='mb-3'>
                        <Card.Header><Card.Title>Imagem do Evento Feira Mobile</Card.Title></Card.Header>
                        <Card.Body>
                            <Form.Row>                        
                                <Form.Group as={Col} md="4" controlId="imagemeventomobile">
                                    <Field  component={Campoupload}
                                    form={form}                                    
                                    name='imagemeventomobile'
                                    label="Imagem do Evento"
                                    numeroupload={1}
                                    preimagens={getPreImagesCampo('imagemeventomobile', eventoselecionado.imagens)}
                                    info="Formato jpg ou png, tamanho máximo de 25k"
                                    resolutionWidth={270}
                                    resolutionHeight={100}
                                    resolutionType="less"
                                    infoResolution="Máximo 270x100"
                                    actionRemoveItem={this.props.eventoselecionadoaction}
                                    itensInitialize={eventoselecionado}
                                    />                                    
                                </Form.Group>                        
                                <Form.Group as={Col} md="4" controlId="imagemeventomobileingles">
                                    <Field  component={Campoupload}
                                    form={form}                                    
                                    name='imagemeventomobileingles'
                                    label="Imagem do Evento Inglês"
                                    preimagens={getPreImagesCampo('imagemeventomobileingles', eventoselecionado.imagens)}
                                    info="Formato jpg ou png, tamanho máximo de 25k"
                                    numeroupload={1}
                                    resolutionWidth={270}
                                    resolutionHeight={100}
                                    resolutionType="less"
                                    infoResolution="Máximo 270x100"
                                    actionRemoveItem={this.props.eventoselecionadoaction}
                                    itensInitialize={eventoselecionado}
                                    />                                    
                                </Form.Group>
                                <Form.Group as={Col} md="4" controlId="imagemeventomobileespanhol">
                                    <Field  component={Campoupload}
                                    form={form}                                    
                                    name='imagemeventomobileespanhol'
                                    label="Imagem do Evento Espanhol"
                                    preimagens={getPreImagesCampo('imagemeventomobileespanhol', eventoselecionado.imagens)}
                                    info="Formato jpg ou png, tamanho máximo de 25k"
                                    numeroupload={1}
                                    resolutionWidth={270}
                                    resolutionHeight={100}
                                    resolutionType="less"
                                    infoResolution="Máximo 270x100"
                                    actionRemoveItem={this.props.eventoselecionadoaction}
                                    itensInitialize={eventoselecionado}
                                    />                                    
                                </Form.Group>                           
                            </Form.Row>                            
                        </Card.Body>
                    </Card>
                    </>
                    :
                    null
                    }

                    {this.state.tipocad==='S'?
                    <Card className='mb-3'>
                        <Card.Header><Card.Title>Imagem do Evento Congresso</Card.Title></Card.Header>
                        <Card.Body>
                            <Form.Row>
                                <Form.Group as={Col} md="4" controlId="imagemcongresso">
                                    <Field  component={Campoupload}
                                    form={form}                                    
                                    name='imagemcongresso'
                                    label="Imagem do Evento"
                                    numeroupload={1}
                                    info="Formato jpg ou png, tamanho máximo de 25k"
                                    />                                    
                                </Form.Group>                        
                                <Form.Group as={Col} md="4" controlId="imagemcongressoingles">
                                    <Field  component={Campoupload}
                                    form={form}                                    
                                    name='imagemcongressoingles'
                                    label="Imagem do Evento Inglês"
                                    numeroupload={1}
                                    info="Formato jpg ou png, tamanho máximo de 25k"
                                    />                                    
                                </Form.Group>
                                <Form.Group as={Col} md="4" controlId="imagemcongressoespanhol">
                                    <Field  component={Campoupload}
                                    form={form}                                    
                                    name='imagemcongressoespanhol'
                                    label="Imagem do Evento Espanhol"
                                    numeroupload={1}
                                    info="Formato jpg ou png, tamanho máximo de 25k"
                                    />                                    
                                </Form.Group>                           
                            </Form.Row>                            
                        </Card.Body>
                    </Card>
                    :
                    null
                    }
                    <Card className='mb-3'>
                        <Card.Header><Card.Title>Validação de Cadastro de Usuários?</Card.Title></Card.Header>
                        <Card.Body>
                            <Form.Row>                        
                                <Form.Group as={Col} md="4" controlId="validacadastro">
                                    <Field type='radio'                                    
                                    label="Sim, envio de código de validação por e-mail" name='validacadastro' component={camporadio} value="S" />                                    
                                </Form.Group>                        
                                <Form.Group as={Col} md="4" controlId="validacadastro">
                                    <Field type='radio'                                    
                                    label="Sem validação" name='validacadastro' component={camporadio} value="N" />
                                </Form.Group>
                            </Form.Row>
                        </Card.Body>
                    </Card> 
                    <Card className='mb-3'>
                        <Card.Header><Card.Title>Data e Horário</Card.Title></Card.Header>
                        <Card.Body>
                            <Form.Row>                        
                                <Form.Group as={Col} md="4" controlId="datainicial">
                                    <Field component={Campocalendario}
                                    form={form}                                    
                                    name='datainicial'
                                    label="Data de Abertura"
                                    />                                    
                                </Form.Group>                        
                                <Form.Group as={Col} md="4" controlId="datafinal">
                                    <Field component={Campocalendario}
                                    form={form}                                   
                                    label="Data de Encerramento"
                                    name='datafinal'
                                    />                                    
                                </Form.Group>
                            </Form.Row>
                            <Form.Row>
                                <Form.Group as={Col} md="3" controlId="horainicial">
                                    <Field type='text'     
                                    placeholder="Ex. 10:30:00"
                                    mask="99:99:99"
                                    label="Hora de Abertura" name='horainicial' component={campotexto} />
                                </Form.Group>
                                <Form.Group as={Col} md="3" controlId="horafinal">
                                    <Field 
                                    type='text'
                                    placeholder="Ex. 18:30:00"
                                    mask="99:99:99"
                                    label="Hora de Encerramento" name='horafinal' component={campotexto} />
                                </Form.Group>                           
                            </Form.Row>
                            <Form.Row>
                                <Form.Group as={Col} md="4" controlId="encerra">
                                    <Field component={Campocalendario}
                                    form={form}                                    
                                    label="Data de Encerramento do Credenciamento"
                                    name='encerra'
                                    />                                    
                                </Form.Group>                         
                            </Form.Row>
                        </Card.Body>                        
                    </Card>
                    <Button 
                        type="submit"
                        onClick={this.handleSubmitLog}
                        disabled={submitSucceeded || pristine}
                        variant="primary" size="lg" block>
                        <Check size="30" />
                        Confirmar
                        {this.props.pendingTasks?
                        <Spinner animation="border"  />
                        :
                        null
                        }
                    </Button>
                </form>
                )
                }}
            />
        );
    }
}

const mapStateToProps = (state) => {
    return {
        cadastroEvento: state.reducerCadastroEvento,
        pendingTasks: state.pendingTasks,
        eventoselecionado: state.reducerEventoSelecionado
    }
}

export default connect(mapStateToProps,{novoatualiza, eventoselecionadoaction, pesquisa})(FormEventos);